import { useAuthStore } from "@/stores/auth";
import { UserDetailSchema, type UserDetail } from "@/types/User";

export const getUserDetail = async (): Promise<UserDetail | null> => {
  const userInfo = useAuthStore().getUserInfo();
  let userDetail = null;
  await axios
    .get("/users/detail?id=" + userInfo.userId)
    .then((response) => {
      userDetail = UserDetailSchema.parse(response.data.result);
    })
    .catch((e) => errorApi(e));
  return userDetail;
};

// New system created and moved to Utility.ts
// export const getUserGroups = async (userDetail: UserDetail): Promise<Code[]> => {
//   if (userDetail.userGroup.name.toLowerCase() !== "all") {
//     return [userDetail.userGroup];
//   } else {
//     let userGroups: Code[] = [];
//     await getCodeTable(CodeTableNumber.USER_GROUPS).then((result: Code[]) => {
//       userGroups = result.filter((code: Code) => code.name.toLowerCase() !== "all");
//     });
//     return userGroups;
//   }
// };
